import React from "react";
import "./Textarea.scss"

const Textarea = ({ label, required, placeholder, value, onChange, errorMessage }) => {
    return (
        <div className="Textarea">
            <div className="label">{label}{required && <span>*</span>}</div>
            <div className="textarea-container">
                <textarea placeholder={placeholder} value={value} onChange={onChange} />
            </div>
            <div className="error-input">{errorMessage}</div>

        </div>
    )
}
export default Textarea